import { Link } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";
import { LOGO } from "@/components/Navbar";
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL, SUPPORT_EMAIL } from "@/lib/config";

export function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-1">
          <span className="inline-flex rounded-md bg-white px-3 py-2">
            <img src={LOGO} alt="SparesHub" className="h-7 w-auto" />
          </span>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
            SparesHub Bulk Liquidation — a B2B spare-parts liquidation marketplace managed by SparesHub.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 rounded-md border border-teal/30 bg-teal/10 px-3 py-1.5 text-xs font-medium text-teal">
            <ShieldCheck weight="fill" size={14} /> Protected by SparesHub Escrow
          </div>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40">Marketplace</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li><Link to="/lots" className="hover:text-white">Browse Lots</Link></li>
            <li><Link to="/sell" className="hover:text-white">Sell Stock</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact Us</Link></li>
            <li><Link to="/login" className="hover:text-white">Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40">Support</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li><a href={`tel:${SUPPORT_PHONE_TEL}`} className="hover:text-white" data-testid="footer-phone">{SUPPORT_PHONE}</a></li>
            <li><a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-white">{SUPPORT_EMAIL}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-white/40">Legal</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li><Link to="/terms-of-use" className="hover:text-white" data-testid="footer-terms-of-use">Terms of Use</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/legal-disclaimer" className="hover:text-white" data-testid="footer-legal-disclaimer">Legal Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-6 text-xs text-white/40 md:flex-row lg:px-8">
          <span>© 2026 Iradium Automobiles Private Limited. All Rights Reserved.</span>
          <span>Prices in ₹ INR · B2B bulk liquidation · Managed by SparesHub</span>
        </div>
      </div>
    </footer>
  );
}
